export const pushEventGTM = (objectToPush) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(objectToPush);
};